import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import PathPanel from './PathPanel.jsx';
import NewDirectoryPanel from './NewDirectoryPanel.jsx';
import UploadPanel from './UploadPanel.jsx';
import ItemsPanel from './ItemsPanel.jsx';
import SelectionConfirmPanel from './SelectionConfirmPanel.jsx';
import { slugify } from '../../../../utils.jsx';
import debounce from 'lodash.debounce';

var cx = require('classnames');

var MediaBrowser = createReactClass({
  propTypes: {
    mediaBrowserType: PropTypes.string,
    onFileSelect: PropTypes.func,
    onClose: PropTypes.func,
    contentSpace: PropTypes.string,
    multipleSelect: PropTypes.bool,
    bulkDeleteMode: PropTypes.bool,
  },

  mediaBrowserRef: React.createRef(),

  getDefaultProps: function () {
    return {
      mediaBrowserType: 'files',
      onFileSelect: function () {},
      onClose: function () {},
      multipleSelect: false,
      bulkDeleteMode: true,
    };
  },

  setSelectedFiles: function (files) {
    var self = this;
    this.setState({ selectedFiles: files }, function () {
      self.uploadFile();
    });
  },

  getInitialState: function () {
    return {
      id: null,
      dir: [],
      items: [],
      selectedFiles: [],
      loading: false,
      dragging: false,
      directoryName: '',
      path: [],
      selectedItems: [],
      filteredItems: [],
      nextOffset: 0,
      subDirsCount: 0,
      loadingBreakpoints: {},
      loadingMore: false,
      selectedFilesForDelete: [],
      selectedFoldersForDelete: [],
    };
  },

  componentDidMount: function () {
    this.changeDirectory(this.state.id);
  },

  createDirectory: function (directoryName) {
    var _this = this;
    var onSuccess = function () {
      _this.refreshDirectory();
    };
    var onError = function () {};

    let data = {
      parent_dir: this.state.id,
      name: directoryName,
    };
    this.props.mediaManager.createDirectory(data).then(onSuccess, onError);
  },

  handleChangeSearch: function (e) {
    const {
      target: { value },
    } = e;

    this.setState({
      search: value,
      filteredItems: this.state.items.filter((item) =>
        slugify(item.name).includes(slugify(value)),
      ),
    });
  },

  uploadFile: function () {
    var _this = this;
    _this.setState({ loading: true });
    var onSuccess = function (data) {
      _this.refreshDirectory();
      _this.setState({ loading: false });
    };

    var onError = function (data) {
      alert('Pri uploade súboru došlo k chybe');
    };

    if (this.state.selectedFiles.length > 0) {
      var data = new FormData();
      this.state.selectedFiles.forEach((file) => {
        data.append('media_file', file);
      });

      data.append('path', this.state.id);
      this.props.mediaManager.uploadFile(data).then(onSuccess, onError);
      // ApiService.uploadFile(this.state.selectedFiles, this.state.id, this.props.contentSpace).then(onSuccess,onError);
    } else {
      alert('Vyberte prosím súbor na odoslanie');
    }
  },

  onItemMove: function (data) {
    var _this = this;
    var onSuccess = function (data) {
      _this.refreshDirectory();
      _this.setState({ loading: false });
    };

    var onError = function () {};
    if (data.file) {
      this.props.mediaManager.moveFile(data).then(onSuccess, onError);
    } else {
      this.props.mediaManager.moveFolder(data).then(onSuccess, onError);
    }
  },

  onItemClick: function (item) {
    if (item.isDirectory === true) {
      if (item.type === 'parent') {
        let dir = this.state.dir;
        this.changeDirectory(dir[dir.length - 1]);
      } else {
        this.changeDirectory(item.id);
      }
    } else {
      this.onFileSelect(item);
    }
  },

  onFileSelect: function (item) {
    if (this.props.multipleSelect) {
      let items = this.state.selectedItems.slice();
      let contains = false;
      items.forEach((sateItem, index) => {
        if (sateItem.id === item.id) {
          items.splice(index, 1);
          contains = true;
        }
      });

      if (!contains) {
        items.push({ id: item.id, content: item });
      }

      this.setState({
        selectedItems: items,
      });
    } else {
      this.props.onFileSelect(item.uri, item);
    }
  },

  onConfirmSelection: function () {
    let uris = this.state.selectedItems.map((element) => {
      return element.content.uri;
    });
    this.props.onFileSelect(uris);
  },

  onBulkSelectItem: function (item, isSelected) {
    if (item.isDirectory) {
      let folders = this.state.selectedFoldersForDelete.slice();
      if (isSelected) {
        folders.push(item.id);
      } else {
        const index = folders.indexOf(item.id);
        if (index > -1) folders.splice(index, 1);
      }
      this.setState({ selectedFoldersForDelete: folders });
    } else {
      let files = this.state.selectedFilesForDelete.slice();
      if (isSelected) {
        files.push(item.id);
      } else {
        const index = files.indexOf(item.id);
        if (index > -1) files.splice(index, 1);
      }
      this.setState({ selectedFilesForDelete: files });
    }
  },

  refreshDirectory: function () {
    this.changeDirectory(this.state.id);
  },

  changeDirectory: function (directory_id) {
    // zmenime adresar
    var _this = this;
    _this.setState({ loading: true, search: null });

    var onSuccess = function (data) {
      var items = [];
      var files = data.files;
      var directories = data.directories;

      for (var i = 0; i < directories.length; i++) {
        let selectedForBulkDelete = false;
        if (_this.props.bulkDeleteMode) {
          selectedForBulkDelete = _this.state.selectedFoldersForDelete.includes(directories[i]._id);
        }

        items.push({
          isDirectory: true,
          isImage: false,
          previewURL: '',
          type: '',
          name: directories[i].name,
          size: 0,
          id: directories[i]._id,
          dir: directories[i].dir,
          selectedForBulkDelete: selectedForBulkDelete,
        });
      }

      const processedFiles = _this.processFiles(
        files,
        _this.state.selectedItems,
      );

      let path = _this.state.path;
      if (data.parent.length > path.length) {
        path.push(data.name);
      } else if (data.parent.length < path.length) {
        path.pop();
      }

      _this.setState({
        items: [...items, ...processedFiles],
        path: path,
        id: data.id,
        dir: data.parent,
        loading: false,
        nextOffset: data.next_offset,
        totalFiles: data.total_files,
        subDirsCount: directories.length,
        loadingBreakpoints: {},
      });
    };

    var onError = function () {
      alert('Pri výpise adresára došlo k chybe');
    };
    this.props.mediaManager
      .loadDirectories(directory_id, 0, 60, 1)
      .then(onSuccess, onError);
  },

  processFiles: function (files, selectedItems) {
    return files.map((file) => {
      var type = file.type;
      var isImage = false;
      if (
        type === 'image/jpeg' ||
        type === 'image/png' ||
        type === 'image/gif'
      ) {
        isImage = true;
      }

      let selected = false;

      selectedItems.forEach((element) => {
        if (element.id === file._id) {
          selected = true;
        }
      });

      let selectedForBulkDelete = false;
      if (this.props.bulkDeleteMode) {
        selectedForBulkDelete = this.state.selectedFilesForDelete.includes(file._id);
      }

      return {
        isDirectory: false,
        isImage: isImage,
        previewURL: '',
        type: file.type,
        name: file.name,
        size: file.size,
        uri: file.uri,
        id: file._id,
        dir: file.dir,
        selected: selected,
        created: file.created,
        selectedForBulkDelete: selectedForBulkDelete,
      };
    });
  },

  infiniteScroll: function () {
    const element = this.mediaBrowserRef.current;
    if (
      element.scrollTop + element.clientHeight > element.scrollHeight - 300 &&
      !this.state.loading
    ) {
      this.loadMore(element.scrollTop + element.clientHeight);
    }
  },

  loadMore: function (loadingBreakpoint, loadAll = false) {
    if (
      this.state.loadingBreakpoints[loadingBreakpoint] ||
      this.state.nextOffset === this.state.totalFiles
    ) {
      return;
    }

    var _this = this;
    const updatedLoadingBreakpoints = {
      ...this.state.loadingBreakpoints,
      [loadingBreakpoint]: true,
    };
    this.setState({
      loading: true,
      loadingMore: true,
      loadingBreakpoints: updatedLoadingBreakpoints,
    });

    function onSuccess(data) {
      const processedFiles = _this.processFiles(
        data.files,
        _this.state.selectedItems,
      );
      const items = [..._this.state.items, ...processedFiles];
      _this.setState({
        loading: false,
        loadingMore: false,
        items: items,
        nextOffset: data.next_offset,
        totalFiles: data.total_files,
      });
    }

    function onError(e) {
      alert('Pri výpise adresára došlo k chybe');
    }

    this.props.mediaManager
      .loadDirectories(
        this.state.id,
        this.state.nextOffset,
        !loadAll ? 60 : null,
        0,
      )
      .then(onSuccess, onError);
  },

  onDeleteItem: function (item) {
    var _this = this;
    _this.setState({ loading: true });
    var onSuccess = function () {
      _this.refreshDirectory();
    };
    var onError = function (error) {
      if (item.isDirectory === true && error.status === 409) {
        alert(
          'Pri mazaní adresára došlo k chybe: Zmazať je možné len prázdny adresár.',
        );
      }
    };
    if (item.isDirectory === true) {
      this.props.mediaManager
        .deleteDirectory(item.path)
        .then(onSuccess, onError);
    } else {
      this.props.mediaManager.deleteFile(item.path).then(onSuccess, onError);
    }
  },

  onBulkDeleteItems: function () {
    const fileCount = this.state.selectedFilesForDelete.length;
    const folderCount = this.state.selectedFoldersForDelete.length;
    const totalCount = fileCount + folderCount;

    if (totalCount === 0) {
      alert('Nie sú vybrané žiadne položky');
      return;
    }

    let confirmMessage = 'Naozaj chcete zmazať ';
    if (fileCount > 0 && folderCount > 0) {
      confirmMessage += `${fileCount} súborov a ${folderCount} priečinkov?`;
    } else if (fileCount > 0) {
      confirmMessage += `${fileCount} súborov?`;
    } else {
      confirmMessage += `${folderCount} priečinkov?`;
    }

    const confirmed = window.confirm(confirmMessage);
    if (!confirmed) return;

    const _this = this;
    _this.setState({ loading: true });

    const data = {
      files: this.state.selectedFilesForDelete,
      dirs: this.state.selectedFoldersForDelete,
    };

    this.props.mediaManager.bulkDelete(data)
      .then((response) => {
        _this.setState({
          selectedFilesForDelete: [],
          selectedFoldersForDelete: [],
        });

        // Skontroluj či sa niektoré položky nepodarilo zmazať
        const failedFiles = response.failedFiles || [];
        const failedDirs = response.failedDirectories || [];
        const hasFailures = failedFiles.length > 0 || failedDirs.length > 0;

        if (hasFailures) {
          let errorMessage = 'Časť položiek sa nepodarilo zmazať:\n\n';

          if (failedDirs.length > 0) {
            errorMessage += `Priečinky: ${failedDirs.length} (pravdepodobne obsahujú podpriečinky alebo súbory)\n`;
          }

          if (failedFiles.length > 0) {
            errorMessage += `Súbory: ${failedFiles.length}\n`;
          }

          alert(errorMessage);
        }

        _this.refreshDirectory();
      })
      .catch((error) => {
        _this.setState({ loading: false });
        if (error.response && error.response.status === 409) {
          alert('Pri mazaní došlo k chybe: Niektoré priečinky nie sú prázdne.');
        } else {
          alert('Pri mazaní položiek došlo k chybe');
        }
        _this.refreshDirectory();
      });
  },

  getUrlParam: function (paramName) {
    var reParam = new RegExp('(?:[?&]|&)' + paramName + '=([^&]+)', 'i');
    var match = window.location.search.match(reParam);

    return match && match.length > 1 ? match[1] : null;
  },

  dropzoneDragEnter: function (event) {
    event.preventDefault();
    this.setState({ dragging: true });
  },

  dropzoneDragOver: function (event) {
    event.preventDefault();
    if (!this.state.dragging) {
      this.setState({ dragging: true });
    }
  },

  dropzoneDragLeave: function (event) {
    event.preventDefault();
    this.setState({ dragging: false });
  },

  dropzoneDrop: function (e) {
    e.preventDefault();
    this.setState({ dragging: false });

    var droppedFiles = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    var files = [];
    for (var i = 0; i < droppedFiles.length; i++) {
      var file = droppedFiles[i];
      if (file.type) {
        files.push(file);
      }
    }
    if (files.length > 0) {
      this.setSelectedFiles(files);
    }

    // ide iba o presun suboru / priecinka vramci struktury
    if (e.dataTransfer.getData('data')) {
      let transferData = JSON.parse(e.dataTransfer.getData('data'));
      if (transferData.id !== this.state.id) {
        let data = {
          file: !transferData.isDir,
          destinationId: this.state.id,
          originId: transferData.id,
        };
        this.onItemMove(data);
      }
    }
  },

  render: function () {
    var classNamesLoader = cx({
      loader: true,
      hidden: !this.state.loading,
    });

    var confirmSelection = cx({
      confirmSelection: true,
      hidden:
        !this.props.multipleSelect || this.state.selectedItems.length === 0,
    });

    var bulkDeletePanel = cx({
      'bulk-delete-panel': true,
      hidden: !this.props.bulkDeleteMode ||
             (this.state.selectedFilesForDelete.length === 0 &&
              this.state.selectedFoldersForDelete.length === 0),
    });

    var dragstyle = {
      border: '3px solid RGB(230, 233, 238)',
    };

    if (this.state.dragging) {
      dragstyle = {
        background: 'RGB(248, 212, 223)',
        border: '3px dashed RGB(153, 84, 113)',
      };
    }

    return (
      <div className="media-browser">
        <div
          className="media-browser-content"
          onDragEnter={this.dropzoneDragEnter}
          onDragOver={this.dropzoneDragOver}
          onDragLeave={this.dropzoneDragLeave}
          onDrop={this.dropzoneDrop}
          style={dragstyle}
          onScroll={debounce(() => this.infiniteScroll(), 100)}
          ref={this.mediaBrowserRef}
        >
          <div className="content-block">
            <PathPanel
              path={this.state.path}
              search={this.state.search}
              onChangeSearch={this.handleChangeSearch}
              disabled={this.state.loading}
            />
            <div className="content-block">
              <div className="content-holder">
                <div className="upload-left">
                  <NewDirectoryPanel createDirectory={this.createDirectory} />
                </div>
                <div className="upload-right">
                  <UploadPanel
                    onSelectFiles={this.setSelectedFiles}
                    onUploadClick={this.uploadFile}
                  />
                </div>
                <div className="cleaner" />
              </div>
            </div>
            <ItemsPanel
              multipleSelect={this.props.multipleSelect}
              bulkDeleteMode={this.props.bulkDeleteMode}
              onBulkSelectItem={this.onBulkSelectItem}
              onItemMove={this.onItemMove}
              onDragEnter={this.dropzoneDragEnter}
              onDragLeave={this.dropzoneDragLeave}
              mediaBrowserType={this.props.mediaBrowserType}
              dir={this.state.dir}
              onDeleteItem={this.onDeleteItem}
              onItemClick={this.onItemClick}
              items={
                this.state.search ? this.state.filteredItems : this.state.items
              }
            />
            {this.state.loadingMore && (
              <div className="load-more-message">
                Načítavajú sa ďalšie obrázky...
              </div>
            )}
          </div>
          {this.state.nextOffset !== 0 && (
            <div className="load-all-images">
              Zobrazených {this.state.nextOffset + this.state.subDirsCount} z {this.state.totalFiles + this.state.subDirsCount}{' '}
              súborov
              {this.state.nextOffset !== this.state.totalFiles && (
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => this.loadMore(-1, true)}
                >
                  Načítať všetky obrázky
                </button>
              )}
            </div>
          )}
          <div className={bulkDeletePanel}>
            <div className="confirm-panel">
              <button
                type="button"
                className="btn btn-danger pull-right"
                onClick={this.onBulkDeleteItems}
              >
                Zmazať vybrané ({this.state.selectedFilesForDelete.length + this.state.selectedFoldersForDelete.length})
              </button>
              <div className="cleaner" />
            </div>
          </div>
          <div className={confirmSelection}>
            {' '}
            <SelectionConfirmPanel
              confirmSelection={this.onConfirmSelection}
              selectedItems={this.state.selectedItems.length}
            />
          </div>
          <div
            className={classNamesLoader}
            style={{
              width: '100px',
              height: '100px',
              position: 'absolute',
              left: '50%',
              top: '50%',
              margin: '-15px -15px 0',
            }}
          />
        </div>
      </div>
    );
  },
});

export default MediaBrowser;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/mediaBrowser/MediaBrowser.jsx